<template>
    <span class="help-block" v-if="text">
        <div v-html="text"></div>
    </span>
</template>

<script>
  export default {
      props: {
          text: {
              type: String,
              default: ''
          }
      }
  }
</script>

<style lang="scss" scoped>
    @import "resources/sass/_variables";

    .help-block {
        color: $secondary-text-color;
    }

    .has-error .help-block {
        display: block;
        color: $warning-color;
    }
</style>
